import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  fetchActivityLogs,
  setActivityLogFilters,
} from "../../../store/slices/activityLogsSlice";

export const useActivityLogsScreen = () => {
  const dispatch = useAppDispatch();

  const { logs, pagination, filters, loading, error } = useAppSelector(
    (state) => state.activityLogs,
  );

  useEffect(() => {
    dispatch(fetchActivityLogs(filters));
  }, [dispatch, filters]);

  const updateFilter = (key: string, value: string | number) => {
    dispatch(
      setActivityLogFilters({
        [key]: value,
        page: key === "page" ? value : 1,
      }),
    );
  };

  const refreshLogs = () => {
    dispatch(fetchActivityLogs(filters));
  };

  return {
    logs,
    pagination,
    filters,
    loading,
    error,
    updateFilter,
    refreshLogs,
  };
};
